import React, { useEffect, useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';
import './PdfRenderer.scss';

// Use local worker file copied by webpack
pdfjs.GlobalWorkerOptions.workerSrc = '/pdf.worker.min.mjs';

const options = {
  cMapUrl: "/cmaps/",
  cMapPacked: true,
  standardFontDataUrl: "/standard_fonts/"
}

const Loading = () => {
  return (
    <div className="pdf-loader">
      <div className="loader-spinner"></div>
    </div>
  );
};

const PdfErrorView = ({ file }) => {
  return (
    <div className="pdf-error-view">
      <div className="error-suggestions">
        <p>Please refresh your screen or <a href={file} download className="download-link">download PDF here</a></p>
      </div>
    </div>
  );
};

const PdfRenderer = ({ file, className }) => {
  const [numPages, setNumPages] = useState(null);
  const [pageWidth, setPageWidth] = useState(Math.min(800, window.innerWidth));

  useEffect(() => {
    const computeWidth = () => setPageWidth(Math.min(800, window.innerWidth));
    window.addEventListener('resize', computeWidth);
    return () => window.removeEventListener('resize', computeWidth);
  }, []);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);        
  };

  const onDocumentLoadError = (error) => {
    console.error('Error loading PDF:', error);
  };

  // Show PDF content
  return (
    <div className={`pdf-renderer ${className || ''}`}>
      <Document
        file={file}
        options={options}
        onLoadSuccess={onDocumentLoadSuccess}
        onLoadError={onDocumentLoadError}
        loading={<Loading />}
        error={<PdfErrorView file={file} />}
      >
        {numPages && Array.from({ length: numPages }, (_, index) => (
          <div key={index + 1} className="pdf-page-container">
            <Page
              pageNumber={index + 1}
              width={pageWidth}
              scale={1}              
            />
          </div>
        ))}
      </Document>
    </div>
  );
};

export default PdfRenderer;
